export function getFilenameFromHeader(header) {
  if (!header) return 'file.xlsx'

  let filename = null

  const utf8Match = header.match(/filename\*\=utf-8''(.+?)(;|$)/i)
  if (utf8Match && utf8Match[1]) {
    try {
      filename = decodeURIComponent(utf8Match[1])
    } catch (e) {
      console.warn('Error in filename', e)
    }
  }

  if (!filename) {
    const filenameMatch = header.match(/filename="?([^";]+)"?/i)
    if (filenameMatch && filenameMatch[1]) {
      filename = filenameMatch[1].replace(/%20/g, ' ').trim()
    }
  }

  if (filename && !filename.toLowerCase().endsWith('.xlsx')) {
    filename += '.xlsx'
  }

  return filename || 'file.xlsx'
}
